import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 3.75C2 2.7835 2.7835 2 3.75 2H20.25C21.2165 2 22 2.7835 22 3.75V20.25C22 21.2165 21.2165 22 20.25 22H3.75C2.7835 22 2 21.2165 2 20.25V3.75ZM3.5 9V20.25C3.5 20.3881 3.61193 20.5 3.75 20.5H7.5L7.5 9H3.5ZM7.5 7.5H3.5V3.75C3.5 3.61193 3.61193 3.5 3.75 3.5H7.5V7.5ZM9 9L9 20.5H20.25C20.3881 20.5 20.5 20.3881 20.5 20.25V9H9ZM20.5 7.5H9V3.5H20.25C20.3881 3.5 20.5 3.61193 20.5 3.75V7.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgTable;
